module.exports = __webpack_public_path__ + "static/media/gq.30ed019c.svg";